import { createElement, memo, useContext, useEffect, useState } from '@max/max';
import View from '@hfe/max-view';
import Image from '@max/leez-image';
import ModalBaseContainer from '@max/leez-modal-base-container';
import ScrollView from '@hfe/max-scrollview';
import LinearGradient from '@hfe/max-linear-gradient';
import TopView from '@max/leez-top-view';
import './index.scss';
const BottomSlideModal = (props) => {
    // 从全局变量global取Context
    const ctx = useContext(global._EngineGlobalContext);
    // 调用引擎注入的自定义API
    const moduleId = ctx._moduleId;
    const { children, headImage, isShowVapImage = false, isShowBottomPopup = false, ifShowCLoseBtn, closeBtn, closeBtnTranslateX = 0, closeBtnTranslateY = 0, backgroundStartColor, backgroundEndColor, borderRadius, height, isListenGlobalEvent = false, staticImg = '', vapUrl = '', vapConfigJson = '', effectUrl = '', minHeight = 236, isLoop = true, isNestedScrollContainer = false, padding = {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
    } } = props;
    const [modalVisible, setModalVisible] = useState(isShowBottomPopup || false);
    useEffect(() => {
        var _a, _b, _c, _d;
        (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.on('texBottomSlideModalStatusChange', ({ status = false }) => {
            console.log("监听到了 texBottomSlideModalStatusChange");
            setModalVisible(status);
        });
        (_b = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _b === void 0 ? void 0 : _b.on('texDailyBottomSlideModalStatusChange', ({ status = false }) => {
            console.log("监听到了 texDailyBottomSlideModalStatusChange");
            setModalVisible(status);
        });
        let handleOpen = () => {
            setModalVisible(true);
        };
        let handleClose = () => {
            setModalVisible(false);
        };
        if (isListenGlobalEvent) {
            (_c = ctx === null || ctx === void 0 ? void 0 : ctx._eventInstance) === null || _c === void 0 ? void 0 : _c.on('windowpop-O32SEHO5', handleOpen);
            (_d = ctx === null || ctx === void 0 ? void 0 : ctx._eventInstance) === null || _d === void 0 ? void 0 : _d.on('closePop-O32SEHO5', handleClose);
        }
        return () => {
            var _a, _b, _c, _d;
            (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.off('texBottomSlideModalStatusChange');
            (_b = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _b === void 0 ? void 0 : _b.off('texDailyBottomSlideModalStatusChange');
            if (isListenGlobalEvent) {
                (_c = ctx === null || ctx === void 0 ? void 0 : ctx._eventInstance) === null || _c === void 0 ? void 0 : _c.off('windowpop-O32SEHO5', handleOpen);
                (_d = ctx === null || ctx === void 0 ? void 0 : ctx._eventInstance) === null || _d === void 0 ? void 0 : _d.off('closePop-O32SEHO5', handleClose);
            }
        };
    }, []);
    const onCloseModal = () => {
        setModalVisible(false);
    };
    return (
    // <View style={{ marginTop: toPx(200) }}>
    <View>
      {/* <Text onClick={() => {setModalVisible(!modalVisible)}}>Hi, {props.content}</Text> */}
      {/* 由于开发环境下预览没有 TopViewProvider，所以MRN无法正常显示，建议发上去测试 */}
      <TopView x-if={modalVisible}>
        <ModalBaseContainer x-if={modalVisible} visible={modalVisible} type="slide" slideFrom="bottom" onMaskPress={onCloseModal} onClosed={onCloseModal}>
          <View onClick={onCloseModal} className="bottom-slide-modal-closeBtn" style={{
            marginBottom: `${closeBtnTranslateY + 20}rpx`,
            marginLeft: `${closeBtnTranslateX}rpx`
        }}>
            <Image x-if={ifShowCLoseBtn && closeBtn} source={{
            uri: closeBtn
        }} style={{
            width: '48rpx'
        }}/>
          </View>
          <Image x-if={!isShowVapImage} source={{
            uri: headImage
        }} style={{
            width: '750rpx'
        }} borderRadius={0}></Image>
          <View style={{
            position: 'relative',
            height: height + 'rpx'
        }}>
              <LinearGradient style={{
            height: height + 'rpx',
            borderTopLeftRadius: borderRadius + 'rpx',
            borderTopRightRadius: borderRadius + 'rpx',
            paddingTop: (padding === null || padding === void 0 ? void 0 : padding.top) + 'rpx',
            paddingBottom: (padding === null || padding === void 0 ? void 0 : padding.bottom) + 'rpx',
            paddingLeft: (padding === null || padding === void 0 ? void 0 : padding.left) + 'rpx',
            paddingRight: (padding === null || padding === void 0 ? void 0 : padding.right) + 'rpx'
        }} start={{
            x: 0,
            y: 0
        }} end={{
            x: 0,
            y: 1
        }} colors={[backgroundStartColor, backgroundEndColor]}>
                <View x-if={isNestedScrollContainer}>
                  {children}
                </View>
                <ScrollView x-if={!isNestedScrollContainer} showsVerticalScrollIndicator={false} style={{
            height: height - padding.top + 'rpx'
        }} contentContainerStyle={{
            flexGrow: 1,
            flexShrink: 0,
            flexBasis: 'auto'
        }}>
                  {children}
                </ScrollView>
              </LinearGradient>
            </View>
        </ModalBaseContainer>
        </TopView>
      </View>);
};
export default memo(BottomSlideModal);
